import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import TextWithInputs from 'src/pages/reportUsage/common/textWithInputs/TextWithInputs';
import TextWithClicks from 'src/pages/reportUsage/common/textWithClicks/TextWithClicks';
import CustomLabel from 'src/pages/reportUsage/common/customLabel/CustomLabel';
import ItemPricesRP from '../../ItemPricesRP';
import edit from 'src/assets/images/Edit.svg';
import AlertMsg from 'src/pages/reportUsage/common/AlertMsg';
import LotSerialRPQtyInput from '../../LotSerialRPQtyInput';
import Checkbox from 'src/common/refactoredComponents/checkbox/Checkbox';
import PoInfoView from '../../PoInfoView';
import { Grid } from '@material-ui/core';
import DeleteLight from 'src/assets/images/DeleteLight.svg';
import Box from '@material-ui/core/Box';
import { sizes } from 'src/styles/Media.styled';
import { Divider } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import { RemovePoText } from 'src/pages/reportUsage/record/components/priceItems/priceButton.styled';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { StyledDiv } from 'src/pages/consignmentBilling/components/billing/BillingContainer.styled';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';

const ItemRPTemplateDesktop = ({
    classes,
    item,
    index,
    editItem,
    editedItemList,
    addSerialNumber,
    lotSerialValueEntered,
    deleteItem,
    displayPrice,
    showBundlefromTableList,
    isChildItem,
    isFromReportScreen,
    checkboxReportPaymentClickHandler,
    checkNewAddedProduct,
    deletePO,
    isCheckBoxSelected,
    myCaseResourceType,
    collapseChildItem,
    showChildItem,
    vendorCaseErrorRedirection,
     childRef,
    onIsSerialUnknown
}) => {
    // const { usageDetails, reportUsageFormObj, setReportUsageFormObj } =
    //     useContext(ReportUsageContext);
    const { t } = useTranslation();
    const showQtyError = item?.isInvalidQtyMsg &&
        (!item.isSplitLotSerialItem ||
            (item.isInvalidQtyMsg !== t('productValidationMessages.qtyRequired') &&
                item.isInvalidQtyMsg !==
                    t('productValidationMessages.mustEnterUsedQuantity')));
    const isLanguageChanged = useSelector(state => state.loginReducer.isLanguageChanged);
    const mediaSizes = {
        titleArea: 6,
        buttonnsArea: 6,
        xs: 3,
        sm: 12,
        lg: 2,
    };
    const winWidth = window.innerWidth;
    const [disableCheckBox, setDisableCheckBox] = useState(false);
    const [showDeleteIcon, setDeleteIcon] = useState(true);

    useEffectWithErrorLogging(() => {
        const value =
            myCaseResourceType === 'reportPayment' &&
            !item.isDeleteButtonPresent &&
            !checkNewAddedProduct
                ? true
                : item.salesOrg != '' && item.salesOrg && item.unitPrice
                ? false
                : true;
        const deleteIcon =
            myCaseResourceType === 'reportPayment' &&
            !item.isDeleteButtonPresent &&
            !checkNewAddedProduct
                ? false
                : true;
        setDisableCheckBox(isChildItem ? true : value);
        setDeleteIcon(deleteIcon);
    }, [item]);

    return (
        <>
            <ItemContainer
                container
                width={isChildItem && '95%!important'}
                alignItems={'flex-start'}
            >
                <ItemDescriptionContainer
                    item
                    sm={6}
                    md={3}
                    lg={3}
                    xl={3}
                    xs={12}
                    padding={isChildItem ? '0 0 0 15px' : '0 0 0 20px'}
                >
                    <span style={{ display: 'flex' }}>
                        <Checkbox
                            checked={isCheckBoxSelected}
                            id={`reportUsage-reportPayment-item-checkbox-${index}`}
                            onCheckboxSelectionChange={(e) =>
                                checkboxReportPaymentClickHandler(
                                    e,
                                    item,
                                    index
                                )
                            }
                            // disabled={
                            //     item.salesOrg != '' && item.salesOrg
                            //         ? false
                            //         : true
                            // }
                            disabled={disableCheckBox}
                        />
                        {/* {!isChildItem && item.isBundleItem && (
                            <img
                                src={collapseIcon}
                                alt="down-arrow"
                                style={{
                                    transform: !showChildItem
                                        ? 'rotate(180deg)'
                                        : '',
                                    cursor: 'pointer',
                                    marginRight: '5px',
                                }}
                                width="20px"
                                height="20px"
                                onClick={() =>
                                    item.isBundleItem &&
                                    item.bundleItem?.length > 0 &&
                                    collapseChildItem(!showChildItem)
                                }
                            />
                        )} */}
                        {item.isEditable ||
                        (item.isInvalidItemMsg ===
                            t('productValidationMessages.invalidProductMsg') &&
                            !item.isBundleItem) ? (
                            <TextWithInputs
                                type="text"
                                name="productCFN"
                                defaultValue={
                                    item.productCFN ? item.productCFN : ''
                                }
                                autoFocus={true}
                                onkeyUp={(e) => editedItemList(e, item, index)}
                                inputHeight={'40px'}
                                inputBorder={
                                    item.isInvalidItemMsg
                                        ? '2px solid #FACFD9'
                                        : '2px solid #EBEDED'
                                }
                                marginLeft={'8px'}
                                isFromAddOrSearch={item.isFromAddOrSearch}
                            />
                        ) : (
                            <TextWithClicks
                                classes={classes}
                                media={mediaSizes}
                                leftTitle={item.productCFN}
                                typeNonTissue={
                                    !item.bundleItem &&
                                    (item.salesOrg === 'S002'
                                        ? 'NT'
                                        : item.salesOrg === 'S030'
                                        ? 'T'
                                        : undefined)
                                }
                                typeEA={!item.bundleItem && item.uom}
                                buttonImg={edit}
                                editAction={() => editItem(item, index)}
                                alignItemsVal={'flex-start'}
                                justifyContentVal={'flex-start'}
                                editMarginLeft={
                                    item.isBundleItem
                                        ? '5px'
                                        : !item.uom &&
                                          !item.salesOrg &&
                                          !item.isBundleItem
                                        ? '60px'
                                        : winWidth <= sizes.mediumDevice &&
                                          '5px'
                                }
                                typeBundle={
                                    item.bundleItem &&
                                    t(
                                        'templates.common.addItemBundlePop.bundleItems.bundle'
                                    )
                                }
                                isChildItem={isChildItem}
                                fromReportPayment={true}
                                item={item}
                                collapseChildItem={collapseChildItem}
                                showChildItem={showChildItem}
                                marginLeft={'8px'}
                                isNewProduct={checkNewAddedProduct}
                                containerMarginLeft={
                                    winWidth > sizes.mediumDevice
                                        ? '10px'
                                        : '0px'
                                }
                            />
                        )}
                    </span>
                    {!item.isEditable && item.description && (
                        <CustomLabel
                            fSize={'13px !important'}
                            label={item.description}
                            letterSpacing={'-0.1px'}
                            color={'#000000'}
                            fontFamily={'AvenirNextWorld Regular'}
                            // paddingLeft={
                            //     item.isBundleItem && !isChildItem && '25px'
                            // }
                            marginLeft={'26px'}
                            minWidth={
                                winWidth > sizes.mobileDevice &&
                                winWidth <= sizes.smalDevice
                                    ? '246px'
                                    : winWidth <= sizes.mobileDevice && '270px'
                            }
                        />
                    )}
                    {item.isInvalidItemMsg && (
                        <div
                            style={{
                                display: 'flex',
                                width: isChildItem ? '100%' : '90%',
                            }}
                        >
                            <AlertMsg message={item.isInvalidItemMsg} />
                        </div>
                    )}
                </ItemDescriptionContainer>
                <SubItemsContainer item md={9} lg={9} xl={9} columns={13}>
                    <ItemsLayout
                        flexDirection={'column'}
                        item
                        xs={12}
                        sm={9}
                        md={9}
                        lg={9}
                        xl={9}
                    >
                        <ItemsLayout
                            item
                            xs={12}
                            sm={12}
                            md={12}
                            lg={12}
                            xl={12}
                        >
                            {/* Edit Icon Grid */}
                            {!checkNewAddedProduct ||
                            item.isSplitLotSerialItem ? null : (
                                <Grid
                                    item
                                    xs={2}
                                    sm={1}
                                    md={1}
                                    lg={1}
                                    xl={1}
                                    style={{
                                        marginLeft: isChildItem && '3px',
                                        display: 'flex',
                                        justifyContent: 'flex-start',
                                        alignItems: 'flex-start',
                                    }}
                                >
                                    {editItem &&
                                        !winWidth <=
                                            sizes.smalDevice && (
                                            <Box
                                             id={`reportUsage-reportPayment-item-edit-button-${index}`}
                                                component={Button}
                                                aria-controls="simple-menu-1"
                                                aria-hospopup="true"
                                                size="small"
                                                width="2rem!important"
                                                height="2rem!important"
                                                minWidth="2rem!important"
                                                minHeight="2rem!important"
                                                marginTop="29px"
                                                border="1px solid #EBEBEB"
                                                marginLeft={
                                                    item.isBundleItem
                                                        ? item.noItemInBundleErr
                                                            ? '14px'
                                                            : ''
                                                        : ''
                                                }
                                                onClick={() =>
                                                    editItem(
                                                        item,
                                                        index
                                                    )
                                                }
                                            >
                                                <img
                                                    src={edit}
                                                    style={{
                                                        width: 24,
                                                        height: 24,
                                                    }}
                                                />
                                            </Box>
                                        )}
                                </Grid>
                            )}
                            <Grid 
                                item 
                                xs={12} 
                                sm={12} 
                                md={12} 
                                lg={12} 
                                xl={12}
                                style={{ 
                                    display: 'flex',
                                    flexDirection: 'column',
                                    width: '100%'
                                }}
                            >
                            {/* LotSerial and ItemPrices - Single iteration row-wise */}
                            {item.lotSerial && item.lotSerial.length > 1 ? (
                                item.lotSerial.map((lotItem, lotItemIdx) => (
                                    <Grid 
                                        container 
                                        key={lotItem.id || lotItemIdx}
                                        style={{ 
                                            display: 'flex', 
                                            flexWrap: 'nowrap',
                                            alignItems: 'flex-start',
                                           // marginTop: lotItemIdx === 0 ? '20px' : '0px'
                                        }}
                                    >
                                        {/* LotSerial Input */}
                                        <Grid
                                            item
                                            xs={12}
                                            sm={6}
                                            md={4}
                                            lg={4}
                                            xl={4}
                                            style={{
                                                marginLeft: isChildItem && '3px',
                                                display: 'flex',
                                                flexDirection: 'column',
                                                justifyContent: 'flex-start',
                                                alignItems: 'flex-start',
                                               // marginTop: lotItemIdx === 0 ? '25px' : '0px'
                                            }}
                                        >
                                            <LotSerialRPQtyInput
                                                item={item}
                                                index={index}
                                                lotItem={lotItem}
                                                lotItemIdx={lotItemIdx}
                                                addSerialNumber={addSerialNumber}
                                                lotSerialValueEntered={lotSerialValueEntered}
                                                showBundlefromTableList={showBundlefromTableList}
                                                isChildItem={isChildItem}
                                                isFromReportScreen={isFromReportScreen}
                                                checkNewAddedProduct={checkNewAddedProduct}
                                                winWidth={winWidth}
                                                lotTextAlign={'center'}
                                                vendorCaseErrorRedirection={vendorCaseErrorRedirection}
                                                ref={lotItemIdx === 0 ? childRef : null}
                                                onIsSerialUnknown={onIsSerialUnknown}
                                                showTopLabel={lotItemIdx === 0}
                                                showAddSerialButton={lotItemIdx === item.lotSerial.length - 1}
                                            />
                                        </Grid>
                                        {/* ItemPrices */}
                                        <Grid 
                                            item 
                                            xs={12} 
                                            md={8} 
                                            lg={8} 
                                            xl={8}
                                        >
                                            {(lotItemIdx === 0 || checkNewAddedProduct) && (
                                            <ItemPricesRP
                                                classes={classes}
                                                displayPrice={displayPrice}
                                                itemPricesWidth={'286px'}
                                                isBundleItem={item.isBundleItem}
                                                checkNewAddedProduct={checkNewAddedProduct}
                                                item={item}
                                                index={index}
                                                lotItem={lotItem}
                                                lotItemIdx={lotItemIdx}
                                                showTopLabel={lotItemIdx === 0}
                                                addSerialNumber={addSerialNumber}
                                                lotSerialValueEntered={lotSerialValueEntered}
                                                isChildItem={isChildItem}
                                                isFromReportScreen={isFromReportScreen}
                                                deleteItem={deleteItem}
                                                winWidth={winWidth}
                                                showDeleteIcon={showDeleteIcon}
                                            />
                                            )}
                                        </Grid>
                                    </Grid>
                                ))
                            ) : (
                                <Grid 
                                    container 
                                    style={{ 
                                        display: 'flex', 
                                        flexWrap: 'nowrap',
                                        alignItems: 'flex-start',
                                    }}
                                >
                                    {/* LotSerial Input - Fallback */}
                                    <Grid
                                        item
                                        xs={12}
                                        sm={6}
                                        md={4}
                                        lg={4}
                                        xl={4}
                                        style={{
                                            marginLeft: isChildItem && '3px',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            justifyContent: 'flex-start',
                                            alignItems: item.isSplitLotSerialItem
                                                ? 'center'
                                                : 'flex-start',
                                            marginTop: item.isSplitLotSerialItem
                                                ? '0px'
                                                : isLanguageChanged
                                                    ? '10px'
                                                    : '17px',
                                            minWidth: 0,
                                            overflow: item.isSplitLotSerialItem
                                                ? 'hidden'
                                                : undefined
                                        }}
                                    >
                                        <LotSerialRPQtyInput
                                            item={item}
                                            index={index}
                                            lotItem={item.lotSerial?.[0]}
                                            lotItemIdx={0}
                                            addSerialNumber={addSerialNumber}
                                            lotSerialValueEntered={lotSerialValueEntered}
                                            showBundlefromTableList={showBundlefromTableList}
                                            isChildItem={isChildItem}
                                            isFromReportScreen={isFromReportScreen}
                                            checkNewAddedProduct={checkNewAddedProduct}
                                            winWidth={winWidth}
                                            lotTextAlign={'center'}
                                            vendorCaseErrorRedirection={vendorCaseErrorRedirection}
                                            ref={childRef}
                                            onIsSerialUnknown={onIsSerialUnknown}
                                            showTopLabel={true}
                                        />
                                    </Grid>
                                    {/* ItemPrices - Fallback */}
                                    <Grid
                                        item
                                        xs={12}
                                        md={9}
                                        lg={9}
                                        xl={9}
                                    >
                                        <ItemPricesRP
                                            classes={classes}
                                            displayPrice={displayPrice}
                                            itemPricesWidth={'286px'}
                                            isBundleItem={item.isBundleItem}
                                            checkNewAddedProduct={checkNewAddedProduct}
                                            item={item}
                                            index={index}
                                            lotItem={item.lotSerial?.[0]}
                                            lotItemIdx={0}
                                            showTopLabel={true}
                                            addSerialNumber={addSerialNumber}
                                            lotSerialValueEntered={lotSerialValueEntered}
                                            isChildItem={isChildItem}
                                            isFromReportScreen={isFromReportScreen}
                                            deleteItem={deleteItem}
                                            winWidth={winWidth}
                                            showDeleteIcon={showDeleteIcon}
                                        />
                                    </Grid>
                                </Grid>
                            )}
                            </Grid>

                            {winWidth <= sizes.mobileDevice &&
                                isFromReportScreen &&
                                !checkNewAddedProduct &&
                                !isChildItem && (
                                    <Grid item xs={4} md={1} lg={1} xl={1}>
                                        <Box
                                         id={`reportUsage-reportPayment-item-delete-button-${index}`}
                                            component={Button}
                                            aria-controls="simple-menu-1"
                                            aria-hospopup="true"
                                            size="small"
                                            width={'40px'}
                                            height={'40px'}
                                            minWidth={'40px !important'}
                                            minHeight={'40px'}
                                            border="1px solid #EBEBEB"
                                            borderRadius={6}
                                            onClick={() =>
                                                deleteItem(index, 0, null, item)
                                            }
                                        >
                                            <img
                                                src={DeleteLight}
                                                style={{
                                                    width: 20,
                                                    height: 20,
                                                }}
                                            />
                                        </Box>
                                    </Grid>
                                )}
                            {winWidth <= sizes.mobileDevice && (
                                <Grid
                                    item
                                    xs={12}
                                    p
                                    style={{ padding: '8px 0px' }}
                                >
                                    <Divider orientation="horizontal" />
                                </Grid>
                            )}
                        </ItemsLayout>
                        <ItemsLayout
                            item
                            md={12}
                            lg={12}
                            xl={12}
                            display={
                                showQtyError ||
                                item?.isInvalidLotSerialMsg
                                    ? 'flex'
                                    : 'none'
                            }
                            flexDirection={'column'}
                            alignItems={'flex-end'}
                        >
                            {' '}
                            {(item?.isInvalidQtyMsg ||
                                item?.isInvalidLotSerialMsg) && (
                                <>
                                    {showQtyError && (
                                        <ErrorContainer>
                                            <AlertMsg
                                                message={item.isInvalidQtyMsg}
                                            />
                                        </ErrorContainer>
                                    )}
                                    {item?.isInvalidLotSerialMsg && (
                                        <ErrorContainer>
                                            <AlertMsg
                                                message={
                                                    item.isInvalidLotSerialMsg
                                                }
                                                linkedSstref={
                                                    item?.isInvalidLotSerialMsg
                                                        ? item?.isInvalidLotSerialMsg?.includes(
                                                              'discard'
                                                          ) &&
                                                          item?.cfn?.startsWith(
                                                              'S33'
                                                          )
                                                            ? item?.linkedSstref
                                                            : ''
                                                        : ''
                                                }
                                                vendorCaseErrorRedirection={
                                                    vendorCaseErrorRedirection
                                                }
                                            />
                                        </ErrorContainer>
                                    )}
                                </>
                            )}
                        </ItemsLayout>
                    </ItemsLayout>
                    <Grid
                        item
                        xs={6}
                        md={3}
                        lg={3}
                        xl={3}
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            height: 'auto',
                            paddingBottom: '10px',
                            justifyContent: checkNewAddedProduct
                                ? 'center'
                                : 'flex-start',
                            alignItems: 'center',
                        }}
                    >
                        {item?.payment?.poAttachment ? (
                            item.payment.poAttachment
                                ?.split(',')
                                .map((ele) => (
                                    <PoInfoView
                                        key={ele}
                                        fileName={ele}
                                        item={item}
                                    />
                                ))
                        ) : (
                            <PoInfoView item={item} />
                        )}
                    </Grid>
                    <Grid
                        item
                        xs={6}
                        md={1}
                        lg={1}
                        xl={1}
                        style={{
                            display: isChildItem ? 'none' : 'flex',
                            justifyContent: 'center',
                            height: checkNewAddedProduct && 'auto',
                            alignItems: checkNewAddedProduct
                                ? 'flex-end'
                                : 'flex-start',
                            maxHeight: checkNewAddedProduct && '63px',
                        }}
                    >
                        {showDeleteIcon &&
                        item.poImageErrorMsg !==
                            t('productValidationMessages.poInfoRequired') ? (
                            <>
                                {winWidth <= sizes.mobileDevice
                                    ? item?.payment &&
                                      item.payment !== '' && (
                                          <RemovePoText
                                           id={`reportUsage-reportPayment-item-removePo-text-${index}`}
                                              onClick={() =>
                                                  item?.payment &&
                                                  item.payment !== '' &&
                                                  deletePO(item, index)
                                              }
                                          >
                                              {t(
                                                  'reportUsage.record.reportPayment.ItemList.ReportPaymentItemListMobile.removePo'
                                              )}
                                          </RemovePoText>
                                      )
                                    : winWidth > sizes.smalDevice &&
                                      item?.payment &&
                                      item.payment !== '' &&
                                      item.payment?.poNumber && (
                                          <Box
                                          id={`reportUsage-reportPayment-item-deletePo-button-${index}`}
                                              component={Button}
                                              aria-controls="simple-menu-1"
                                              aria-hospopup="true"
                                              size="small"
                                              width={'35px!important'}
                                              height={'35px!important'}
                                              minWidth={'35px!important'}
                                              minHeight={'35px!important'}
                                              border="1px solid #EBEBEB"
                                              borderRadius={6}
                                              onClick={() =>
                                                  deletePO(item, index)
                                              }
                                          >
                                              <img
                                                  src={DeleteLight}
                                                  alt={'delete'}
                                                  style={{
                                                      // marginLeft: '4.7vw',
                                                      cursor: 'pointer',
                                                      width: '24px',
                                                      height: '24px',
                                                  }}
                                              />
                                          </Box>
                                      )}
                            </>
                        ) : null}
                    </Grid>
                </SubItemsContainer>
                {/* {(item?.isInvalidQtyMsg || item?.isInvalidLotSerialMsg) && (
                    <>
                        <Grid item sm={6} md={3} lg={3} xl={3} xs={12}></Grid>
                        <Grid item md={9} lg={9} xl={9} columns={13}>
                            {item?.isInvalidQtyMsg && (
                                <div style={{ display: 'flex', width: '100%' }}>
                                    <AlertMsg message={item.isInvalidQtyMsg} />
                                </div>
                            )}
                            {item?.isInvalidLotSerialMsg && (
                                <div style={{ display: 'flex', width: '100%' }}>
                                    <AlertMsg
                                        message={item.isInvalidLotSerialMsg}
                                    />
                                </div>
                            )}
                        </Grid>
                    </>
                )} */}
            </ItemContainer>
            {item?.lotSerialUnknownApplicable &&  (item?.isSerialRequired ||item?.isBatchRequired) && (
                <StyledDiv 
                    marginLeft={0} 
                    margin={`20px 0px 0px ${
                        winWidth <= sizes.smalDevice 
                            ? '200px'  // Mobile/Small tablets (≤768px)
                            : winWidth <= sizes.ipadAir 
                                ? '209px'  // iPad Mini/iPad 9th gen (769-820px)
                                : winWidth <= sizes.mediumDevice 
                                    ? '240px'  // iPad Air/iPad Pro portrait (821-1024px)
                                    : winWidth <= sizes.largeDevice 
                                        ? '270px'  // Large tablets/small desktop (1025-1280px)
                                        : '285px'  // Desktop (>1280px)
                    }`}
                >
                     <Checkbox
                     id={`reportUsage-reportPayment-item-lotSerialUnknown-checkbox-${index}`}
                                            label={t(
                                                'reportUsage.lotSerialUnknown'
                                            )}
                                            checked={
                                                item?.lotSerialUnknown
                                                    ? item?.lotSerialUnknown
                                                    : !item?.lotSerialUnknownApplicable
                                            }
                                            onCheckboxSelectionChange={() =>
                                                onIsSerialUnknown(
                                                    item,
                                                    index,
                                                    item?.lotSerialUnknown ===
                                                        true ||
                                                       item?.lotSerialUnknown ===
                                                            false

                                                        ? !item?.lotSerialUnknown
                                                        : item?.lotSerialUnknownApplicable,
                                                    0
                                            
                                                )
                                            }
                                            fontSize={'12px'}
                                            color={'#373737'}
                                            margin={'2px 8px 0px 0px'}
                    />
                </StyledDiv>
            )}
        </>
    );
};

export default ItemRPTemplateDesktop;

export const SubItemsContainer = styled(Grid)`
    display: flex;
`;
export const ItemContainer = styled(Grid)`
    padding: 0;
    align-items: ${({ alignItems }) => alignItems};
    width: ${({ width }) => width};
`;
export const ItemDescriptionContainer = styled(Grid)`
    padding: ${({ padding }) => padding};
`;
export const ItemsLayout = styled(Grid)`
    display: ${({ display }) => (display ? display : 'flex')};
    flex-direction: ${({ flexDirection }) => flexDirection};
    align-items: ${({ alignItems }) => alignItems};
    justify-content: ${({ justifyContent }) => justifyContent};
`;
export const ErrorContainer = styled.div`
    display: flex;
    width: calc(100% - 5%);
`;
